import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morphProductBlock } from '@theme/morph';
import { Component } from '@theme/component';


class ProductSKU extends Component {
  /** @type {Element | null} - Cached section/dialog the variant listener is attached to. */
  #variantUpdateTarget = null;

  connectedCallback() {
    super.connectedCallback();
    this.#variantUpdateTarget = this.closest('.shopify-section, dialog');
    this.#variantUpdateTarget?.addEventListener(ThemeEvents.variantUpdate, this.updateSKU);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#variantUpdateTarget?.removeEventListener(ThemeEvents.variantUpdate, this.updateSKU);
  }

  /**
   * Updates the SKU.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateSKU = (event) => {
    if (this.dataset.stickyAtc) return;
    morphProductBlock(this, event);
  };
}

if (!customElements.get('product-sku')) {
  customElements.define('product-sku', ProductSKU);
}
